const MINOR_UNITS_PER_MAJOR_UNIT = 100;
const CURRENCY_FRACTION_DIGITS = 2;
/**
 * Formats an amount given in minor units (grosze, cents) as a localized currency
 * string.
 *
 * The language is a parameter rather than a read from a shared store: applications
 * remount the routed tree on a language switch, so every call site already holds
 * the active language, and this package stays free of any locale dependency.
 */
export const formatFlatPrice = (flatPrice, language) => new Intl.NumberFormat(language, {
    style: 'currency',
    currency: flatPrice.currency,
    minimumFractionDigits: CURRENCY_FRACTION_DIGITS,
}).format(flatPrice.amount / MINOR_UNITS_PER_MAJOR_UNIT);
